
export const PROTOCOL_ID = '/multistream/1.0.0'
